import React from "react";
import ReactQuill from "react-quill";
import { Card, CardBody, Form, FormInput, Button, Col, Row, Container } from "shards-react";

import "react-quill/dist/quill.snow.css";
import "../../assets/quill.css";

import moment from 'moment';

import { getTask } from "../../services/taskServices";
import MainListComponent from "../../components/MainListComponent";


class TaskDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        listTask: []
    }
  }

  componentDidMount = async () => {
      try {
        let { data, error } = await getTask(this.props.row._id);
        if (error) {
            throw error
        }
        console.log(data)
        this.setState({
            listTask: data.listTask
        })
      } catch (error) {

      }
  }

  render() {
    const valueCustomator = {
        createdDate: data => {
            return moment(
            data.createdDate && data.createdDate ? data.createdDate : ''
            ).format('YYYY/MM/DD H:mm:ss')
        },
        dateFinish: data => {
            return moment(
            data.dateFinish && data.dateFinish ? data.dateFinish : ''
            ).format('YYYY/MM/DD')
        },
        taskId: data => {
            return data.taskId ? data.taskId : '-'
        },
        title: data => {
            return data.task ? data.task : '-'
        },
        status: data => {
            if (data.status) {
                // newtask ongoing finish priority cancelled late
                if (data.status === "newtask") {
                    return 'New Task'
                }
                if (data.status === "ongoing") {
                    return 'Ongoing'
                }
                if (data.status === "finish") {
                    return 'Finish'
                }
                if (data.status === "priority") {
                    return 'Priority'
                }
                if (data.status === "cancelled") {
                    return 'Cancelled'
                }
                if (data.status === "late") {
                    return 'Late'
                }
                return '-'
            } else {
                return '-'
            }
        },
        // admin: data => {
        //     return data.admin ? data.admin.name ? data.admin.name : "-" : "-"
        // },
        // tasksCount: data => {
        //     return data.listTask ? data.listTask.length : 0
        // },
        // completionCount: data => {
        //     return 0;
        // }
    } 
    const columns = [
        {
            name: 'createdDate',
            title: 'Created Date',
            valueCustomator: valueCustomator.createdDate
        },
        {
            name: 'taskId',
            title: 'Task Id',
            valueCustomator: valueCustomator.taskId
        },
        {
            name: 'title',
            title: 'Task Title',
            valueCustomator: valueCustomator.title
        },
        {
            name: 'status',
            title: 'Status',
            valueCustomator: valueCustomator.status
        },
        // {
        //     name: 'admin',
        //     title: 'Create By',
        //     valueCustomator: valueCustomator.admin
        // },
        // {
        //     name: 'listTask',
        //     title: 'Tasks',
        //     valueCustomator: valueCustomator.tasksCount
        // },
        // {
        //     name: 'listTask',
        //     title: 'Completion',
        //     valueCustomator: valueCustomator.completionCount
        // },
        // {
        //     name: 'dateFinish',
        //     title: 'Deadline',
        //     valueCustomator: valueCustomator.dateFinish
        // },
    ];
    const columnWidths = [
        { columnName: 'createdDate', width: 180 },
        { columnName: 'taskId', width: 180 },
        { columnName: 'title', width: 300 },
        { columnName: 'admin', width: 200 },
        { columnName: 'listTask', width: 100 },
        { columnName: 'dateFinish', width: 80 },
        { columnName: 'status', width: 80 },
    ];
    return (
        <Container fluid className="main-content-container px-4 pb-4">
            <Col className="mt-4">
                {/* <Row className="mb-2">
                    <Button
                        onClick={(e) => {
                            this.props.history.push('/task/add-new-task');
                        }}
                    >Add New Task</Button>
                </Row> */}
                <Row>
                    <MainListComponent
                        rows={this.state.listTask}
                        columns={columns}
                        columnWidths={columnWidths}
                        // currentPage={currentPage}
                        // pageSize={pageSize}
                        // totalCount={totalCount}
                        // isUseBackendPaging={isUseBackendPaging}
                        // noBackendPagingPageSizes={noBackendPagingPageSizes}
                        // onCurrentPageChange={(e) => onCurrentPageChange(e)}
                        // onLoading={onLoading}
                        // sorting={sorting}
                        // columnWidths={columnWidths}
                        // onSortingChange={onSortingChange}
                    />
                </Row>
            </Col>
        </Container>
    )
  }
}

export default TaskDetail;